<template>
  <div class="full-container">
    <div
        style="width: 100%;float: left;height: 50px;line-height: 50px;font-size: 0.9rem; text-align: left;opacity: 0.9;">
      平台首页
    </div>

    <div style="width: 100%;float: left; text-align: left;   font-weight: 600;opacity: 0.9;height: 40px;line-height: 40px;">
      数据统计
    </div>
    <div style="width:100%;height:auto;float:left;border-radius: 15px;padding-bottom:40px;">
      <div v-if="orderCount" style="width: 100%;float: left;margin-bottom: 25px">
        <div style="width:31.25%;float: left; " @click="gotoOrderPage">
          <el-card class="box-card" style="cursor: pointer">
            <t-space align="center">
              <t-statistic :value="orderCount?orderCount.todayOrderCount+'':'0'" color="red" title="今天订单量"
                           trend="increase" unit="单"/>
              <t-icon class="icon" name="task"
                      style="font-size: 3rem;background-color:#E1F0EC;padding:10px;border-radius:100px;color: #37b48a"/>
            </t-space>
          </el-card>
        </div>
        <div style="width:31.25%;float: left;margin-left: 3%; " @click="gotoOrderPage">
          <el-card class="box-card" style="cursor: pointer">
            <t-space align="center">
              <t-statistic :value="orderCount?orderCount.allOrderCount+'':'0'" color="red" title="总订单量"
                           unit="单"/>
              <t-icon class="icon" name="task"
                      style="font-size: 3rem;background-color:#E1F0EC;padding:10px;border-radius:100px;color: #37b48a"/>
            </t-space>
          </el-card>
        </div>
        <div style="width:31.25%;float: left; margin-left: 3%;" @click="gotoOrderPage">
          <el-card class="box-card" style="cursor: pointer">
            <t-space align="center">
              <t-statistic :value="orderCount&&orderCount.allPayMoney?orderCount.allPayMoney+'':'0.00'" color="red"
                           title="总成交额"
                           unit="￥"/>
              <t-icon class="icon" name="money"
                      style="font-size: 3rem;background-color:#E1F0EC;padding:10px;border-radius:100px;color: #37b48a"/>
            </t-space>
          </el-card>
        </div>

        <div style="width:31.25%;float: left;margin-top: 16px " @click="gotoOrderSettlementPage">
          <el-card class="box-card" style="cursor: pointer">
            <t-space align="center">
              <t-statistic :value="orderSettlementCount?orderSettlementCount:'0.00'" color="red"
                           title="提现总额"
                           unit="￥"/>
              <t-icon class="icon" name="money"
                      style="font-size: 3rem;background-color:#E1F0EC;padding:10px;border-radius:100px;color: #37b48a"/>
            </t-space>
          </el-card>
        </div>

        <div style="width:31.25%;float: left; margin-top: 16px;margin-left: 3%;" @click="gotoUserPage">
          <el-card class="box-card" style="cursor: pointer">
            <t-space align="center">
              <t-statistic :value="userCount?userCount:'0'" color="red"
                           title="用户"
              />
              <t-icon class="icon" name="user-1"
                      style="font-size: 3rem;background-color:#E1F0EC;padding:10px;border-radius:100px;color: #37b48a"/>
            </t-space>
          </el-card>
        </div>

        <div style="width:31.25%;float: left; margin-top: 16px;margin-left: 3%;" @click="gotoSquarePage">
          <el-card class="box-card" style="cursor: pointer">
            <t-space align="center">
              <t-statistic :value="squareCount?squareCount:'0'" color="red"
                           title="供需市场"
                           unit="条"/>
              <t-icon class="icon" name="attic"
                      style="font-size: 3rem;background-color:#E1F0EC;padding:10px;border-radius:100px;color: #37b48a"/>
            </t-space>
          </el-card>
        </div>

        <div style="width:31.25%;float: left; margin-top: 16px;" @click="gotoMerchantPage">
          <el-card class="box-card" style="cursor: pointer">
            <t-space align="center">
              <t-statistic :value="merchantCount?merchantCount:'0'" color="red"
                           title="商户"
              />
              <t-icon class="icon" name="usergroup"
                      style="font-size: 3rem;background-color:#E1F0EC;padding:10px;border-radius:100px;color: #37b48a"/>
            </t-space>


          </el-card>
        </div>

        <div style="width:31.25%;float: left; margin-top: 16px;margin-left: 3%;" @click="gotoProductPage">
          <el-card class="box-card" style="cursor: pointer">
            <t-space align="center">
              <t-statistic :value="productCount?productCount:'0'" color="red"
                           title="商品"
              />
              <t-icon class="icon" name="control-platform"
                      style="font-size: 3rem;background-color:#E1F0EC;padding:10px;border-radius:100px;color: #37b48a"/>
            </t-space>
          </el-card>
        </div>
      </div>

      <!--    echarts -->
      <div
          style="width:100%;height:auto;float:left;border-radius: 15px;margin-right: 3%;background-color:white;padding: 20px;">
        <div ref="taskSumCharts" style="width: 100%;min-height: 560px;float: left;"></div>
      </div>

      <div v-if="false"
           style="width:48.5%;height:auto;float:left;border-radius: 15px;margin-right: 3%;background-color:white;padding: 20px;margin-top: 25px;">
        <div ref="productServiceCharts" style="width: 100%;min-height: 260px;float: left;"></div>
      </div>
      <div v-if="false"
           style="width:48.5%;height:auto;float:left;border-radius: 15px;background-color:white;padding: 20px;margin-top: 25px;">
        <div ref="workflowCharts" style="width: 100%;min-height: 260px;float: left;"></div>
      </div>
    </div>

  </div>
</template>

<script>
import * as echarts from "echarts";
import {
  countAllOrderApi,
  countMoneyAllOrderApi,
  countProductServiceAllOrderApi,
  countWorkflowDetailAllOrderApi
} from "@/router/api/order/order-api";

import {countAllSettlementMoneyApi, countMerchantSettlementMoneyApi} from "@/router/api/order/order-settlement-api";
import {countAllSquareApi} from "@/router/api/square/square-api";
import {countAllMerchantApi} from "@/router/api/merchant/merchant-api";
import {countAllProductApi} from "@/router/api/product/product-api";
import {countAllUserApi} from "@/router/api/user-api";

export default {
  name: "Index",
  data() {
    return {
      orderCount: null,
      squareCount: 0,

      orderSettlementCount : 0.00,
      merchantCount: 0,
      productCount: 0,
      userCount: 0,


      settlementMoney: 0.00,

      // 折线图
      taskSumCharts: null,
      orderMoneyList: [],
      dayList: [],
      orderDayList: [],

      productServiceCharts: null,
      productServiceList: [],
      productValue: 0,
      serviceValue: 0,

      //流程服务
      workflowCharts: null,
      workflowDetail: [],
      workflowDetailTitle: [],
      workflowDetailValue: []


    };
  },

  mounted() {
    this.load();
  },

  methods: {

    load() {

      this.countAllSquare();
      this.countAllMerchant();
      this.countAllProduct();
      this.countAllSettlementMoney();
      this.countAllUser();


      countAllOrderApi({}, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.orderCount = res.data.resultSetData;
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });

      countMerchantSettlementMoneyApi({}, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              let settlementMoney = res.data.resultSetData;
              if (settlementMoney && settlementMoney.value) {
                this.settlementMoney = settlementMoney.value;
                if (this.settlementMoney) {
                  this.settlementMoney = (this.settlementMoney * 0.994).toFixed(2);
                }
              }
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });

      this.countMoneyMerchantOrder();

      this.countProductServiceOrder();


    },

    countMoneyMerchantOrder() {
      this.taskSumCharts = echarts.init(this.$refs.taskSumCharts);
      countMoneyAllOrderApi({}, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.orderMoneyList = res.data.resultSetData;
              if (this.orderMoneyList) {
                for (let i = 0; i < this.orderMoneyList.length; i++) {
                  let dataDay = this.orderMoneyList[i];
                  if (dataDay) {
                    this.dayList.push(dataDay.day);
                    this.orderDayList.push(dataDay.everyDayCount);
                  }
                }
              }
              this.loadMyOrderMoneyChants();
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },


    countAllSquare() {
      countAllSquareApi({}, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.squareCount = res.data.resultSetData;
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },

    countAllMerchant() {
      countAllMerchantApi({}, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.merchantCount = res.data.resultSetData;
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },

    countAllProduct() {
      countAllProductApi({}, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.productCount = res.data.resultSetData;
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },


    countAllSettlementMoney() {
      countAllSettlementMoneyApi({}, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.orderSettlementCount = res.data.resultSetData;
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },

    countAllUser() {
      countAllUserApi({}, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.userCount = res.data.resultSetData;
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },

    countProductServiceOrder() {
      this.productServiceCharts = echarts.init(this.$refs.productServiceCharts);
      countProductServiceAllOrderApi({}, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.productServiceList = res.data.resultSetData;
              if (this.productServiceList) {
                for (let i = 0; i < this.productServiceList.length; i++) {
                  let productService = this.productServiceList[i];
                  if (productService && productService.key == "农产品") {
                    this.productValue = productService.value;
                  }
                  if (productService && productService.key == "农服务") {
                    this.serviceValue = productService.value;
                  }
                }
              }
              this.loadProductServiceChants();
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },

    countWorkflowDetailOrder() {
      this.workflowCharts = echarts.init(this.$refs.workflowCharts);
      countWorkflowDetailAllOrderApi({}, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              let workflowDetailList = res.data.resultSetData;
              for (let i = 0; i < workflowDetailList.length; i++) {
                let workflowDetail = workflowDetailList[i];
                if (workflowDetail) {
                  this.workflowDetailTitle.push(workflowDetail.workflowTypeStr);
                  this.workflowDetailValue.push({
                    value: workflowDetail.count,
                    name: workflowDetail.workflowTypeStr
                  });

                }
              }
              this.loadWorkflowChants();
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },


    loadMyOrderMoneyChants() {
      let option = {
        color: ["#E1F0EC"],
        title: {
          text: "本月订单量"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          data: ["订单曲线"]
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.dayList
          }
        ],
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            name: "订单量",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#37b48a"
                },
                {
                  offset: 1,
                  color: "#E1F0EC"
                }
              ])
            },
            emphasis: {
              focus: "series"
            },
            data: this.orderDayList
          }

        ]
      };

      this.taskSumCharts.clear();
      this.taskSumCharts.setOption(option);
      let thizz = this;
      this.taskSumCharts.on('click', function (param) {
        thizz.gotoOrderPage();
      })

    },

    loadProductServiceChants() {

      let option = {
        title: {
          text: "农产品与农服务 订单比例",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["农产品", "农服务"]
        },
        series: [
          {
            name: "订单数据",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [
              {
                value: this.productValue,
                name: "农产品",
                itemStyle: {
                  color: "#37b48a"
                }
              },
              {
                value: this.serviceValue,
                name: "农服务",
                itemStyle: {
                  color: "#e1f0ec"
                }
              }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };
      this.productServiceCharts.clear();
      this.productServiceCharts.setOption(option);
    },

    loadWorkflowChants() {

      let option = {
        title: {
          text: "农服务子流程比例",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: this.workflowDetailTitle
        },
        series: [
          {
            name: "订单数据",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: this.workflowDetailValue,
            // data: [
            //   {
            //     value: 335,
            //     name: "农产品"
            //   },
            //   {
            //     value: 310, name: "农服务"
            //   }
            // ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };
      this.workflowCharts.clear();
      this.workflowCharts.setOption(option);
    },


    gotoOrderPage() {
      this.$router.push("/orderIndex");
    },
    gotoOrderSettlementPage() {
      this.$router.push("/orderSettlementIndex");
    },

    gotoSquarePage() {
      this.$router.push("/squareIndex");
    },


    gotoUserPage() {
      this.$router.push("/userIndex");
    },

    gotoMerchantPage() {
      this.$router.push("/merchantIndex");
    },

    gotoProductPage() {
      this.$router.push("/productIndex");
    },


    // 工具

    parseDate(date) {
      if (date) {
        return new Date(date).toLocaleString();
      }
      return "";
    }


  }

};

</script>


<style scoped>


</style>
